import {
  ArrowBackIcon_default
} from "./chunk-YZURJNAI.js";

// src/NavigationModalHeader.tsx
import IconButton from "@mui/joy/IconButton";
import ModalClose from "@mui/joy/ModalClose";
import { styled, useThemeProps } from "@mui/joy/styles";
import useSlot from "@mui/joy/utils/useSlot";
import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
var name = "LevanaNavigationModalHeader";
var NavigationModalHeaderRoot = styled("div", {
  name,
  slot: "root"
})({
  textAlign: "center",
  paddingTop: "var(--ModalContent-padding)",
  paddingInline: "var(--ModalContent-padding)"
});
var NavigationModalHeaderClose = styled(ModalClose, {
  name,
  slot: "close"
})({});
var NavigationModalHeader = forwardRef(function NavigationModalHeader2(inProps, ref) {
  const props = useThemeProps({ props: inProps, name });
  const { onBack, canClose, topDecorator, children, ...otherProps } = props;
  const ownerState = { ...props, canClose };
  const externalForwardedProps = { ...otherProps };
  const [SlotRoot, rootProps] = useSlot("root", {
    ref,
    className: "root",
    elementType: NavigationModalHeaderRoot,
    ownerState,
    externalForwardedProps
  });
  const [SlotClose, closeProps] = useSlot("close", {
    ref,
    className: "close",
    elementType: NavigationModalHeaderClose,
    ownerState,
    externalForwardedProps,
    internalForwardedProps: {
      color: "neutral",
      variant: "outlined",
      "aria-label": "close"
    }
  });
  return /* @__PURE__ */ jsxs(SlotRoot, { ...rootProps, children: [
    topDecorator,
    onBack && /* @__PURE__ */ jsx(
      IconButton,
      {
        onClick: onBack,
        color: "neutral",
        variant: "outlined",
        sx: {
          position: "absolute",
          top: "var(--ModalClose-inset)",
          left: "var(--ModalClose-inset)"
        },
        "aria-label": "back",
        children: /* @__PURE__ */ jsx(ArrowBackIcon_default, {})
      }
    ),
    children,
    canClose && /* @__PURE__ */ jsx(SlotClose, { ...closeProps })
  ] });
});
var NavigationModalHeader_default = NavigationModalHeader;

export {
  NavigationModalHeader_default
};
